import View from './view';
export const CardNumber = View;
